import { useCallback, useEffect, useState } from "react";
import TextInput from "@joinTrilo/ui/atoms/TextInput";
import { StyledWrapper } from "@joinTrilo/ui/atoms/TextInput/TextInput.styled";

type EmailProps = {
    setEmail: (email: string | undefined) => void;
};

const INPUT_EMAIL = "email";

export const Email = ({ setEmail: updateEmail }: EmailProps) => {
    const [email, setEmail] = useState("");
    const [emailValid, setEmailValid] = useState(false);

    const checkEmailValid = useCallback(() => {
        let emailValid = false;
        if (email.match(/\S+@\S+\.\S+/)) {
            emailValid = true;
        }
        return emailValid;
    }, [email]);

    useEffect(() => {
        setEmailValid(false);
        if (email) {
            setEmailValid(checkEmailValid());
        }
    }, [email, setEmailValid, checkEmailValid]);

    useEffect(() => {
        if (emailValid) {
            updateEmail(email);
        } else {
            updateEmail(undefined);
        }
    }, [email, emailValid, updateEmail]);

    return (
        <>
            <StyledWrapper>
                <TextInput
                    inputStyle="regular"
                    autoComplete="username"
                    autoCapitalize="none"
                    label="Email address"
                    placeholder="Email address"
                    type="email"
                    name={INPUT_EMAIL}
                    id={INPUT_EMAIL}
                    value={email} // TODO: this might need to be removed
                    onChange={(e) => setEmail(e.target.value)}
                    onFocus={() => true}
                    onBlur={() => false}
                    // invalid={!emailFocused && emailError}
                    // valid={this.state.emailValid}
                    disabled={false}
                />
            </StyledWrapper>
        </>
    );
};
